import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  Button,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  LocationOn,
  MyLocation,
  Fullscreen,
  FullscreenExit,
  Close
} from '@mui/icons-material';
import GoogleMap from './GoogleMap';
import './MapView.css';





const MapView = ({ missions = [], onMissionClick }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [userLocation, setUserLocation] = useState(null);
  const [selectedMission, setSelectedMission] = useState(null);
  


  // Obtenir la géolocalisation de l'utilisateur
  const getUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
        },
        (error) => {
          console.error('Erreur de géolocalisation:', error);
        }
      );
    }
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  const handleMissionClick = (mission) => {
    setSelectedMission(mission);
    if (onMissionClick) {
      onMissionClick(mission);
    }
  };



  return (
    <Box className={`map-view ${isFullscreen ? 'map-view--fullscreen' : ''}`}>
      <Box className="map-controls">
        <Tooltip title="Ma position">
          <IconButton onClick={getUserLocation} size="small">
            <MyLocation />
          </IconButton>
        </Tooltip>
        <Tooltip title={isFullscreen ? 'Quitter le plein écran' : 'Plein écran'}>
          <IconButton onClick={toggleFullscreen} size="small">
            {isFullscreen ? <FullscreenExit /> : <Fullscreen />}
          </IconButton>
        </Tooltip>
      </Box>

      <Box className="map-container" sx={{ height: isFullscreen ? '100vh' : '400px' }}>
        <GoogleMap
          missions={missions}
          onMissionClick={handleMissionClick}
          style={{ width: '100%', height: '100%', borderRadius: '8px' }}
        />
      </Box>

      {/* Informations sur les missions */}
      <Box className="map-info" sx={{ mt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {missions.length} mission{missions.length > 1 ? 's' : ''} affichée{missions.length > 1 ? 's' : ''} sur la carte
        </Typography>
        {userLocation && (
          <Typography variant="body2" color="primary" sx={{ mt: 1 }}>
            📍 Position actuelle détectée
          </Typography>
        )}
      </Box>

      {/* Mission sélectionnée */}
      {selectedMission && (
        <Card className="selected-mission-card" sx={{ mt: 2 }}>
          <CardContent>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start">
              <Box flex={1}>
                <Typography variant="h6" gutterBottom>
                  {selectedMission.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {selectedMission.organization?.name || selectedMission.organization}
                </Typography>
                <Box display="flex" gap={1} mb={2}>
                  <Chip 
                    label={selectedMission.discipline} 
                    size="small" 
                    color="primary" 
                    variant="outlined"
                  />
                  <Chip 
                    label={selectedMission.location} 
                    size="small" 
                    icon={<LocationOn />}
                  />
                </Box>
                <Typography variant="h6" color="primary">
                  {selectedMission.rate}
                </Typography>
              </Box>
              <IconButton 
                onClick={() => setSelectedMission(null)}
                size="small"
              >
                <Close />
              </IconButton>
            </Box>
            <Button 
              variant="contained" 
              fullWidth 
              sx={{ mt: 2 }}
              onClick={() => handleMissionClick(selectedMission)}
            >
              Voir les détails
            </Button>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default MapView;